// extracted by mini-css-extract-plugin
module.exports = {"error":"error-2zl1J","disabled":"disabled-3yEz2","new-page":"new-page-N1zZa","newPage":"new-page-N1zZa","label":"label-2H5P8","action":"action-BkUaf","form":"form-2zIpi"};